import { render, staticRenderFns } from "./GoalItem.vue?vue&type=template&id=5df895c0&scoped=true"
import script from "./GoalItem.vue?vue&type=script&lang=js"
export * from "./GoalItem.vue?vue&type=script&lang=js"
import style0 from "./GoalItem.vue?vue&type=style&index=0&id=5df895c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df895c0",
  null
  
)

export default component.exports